import axios from 'axios';

// Función para obtener información del producto por ID
const getProductInfo = async ({idproduct, currency, tokenRef, slug, token = null}, signal) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded', 
      // 'X-Requested-With': 'XMLHttpRequest'
    };

    // Agrega el token de autorización si está presente
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.post(apiUrl, new URLSearchParams({
      type: 'getPeriodPlan',
      pid: idproduct,
      currency: currency,
      tokenRef: tokenRef,
      slug: slug,
      responsetype: 'json',
    }), {
      headers,
      signal
    });
 
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default getProductInfo;
